class CommentFormController {
  constructor(Auth) {
    'ngInject';

    this.Auth = Auth;
  }

  $onInit() {
    this.Auth.getCurrentUser().then(this.initComment.bind(this));
  }

  initComment(currentEngineer) {
    this.comment = {
      owner: currentEngineer,
      body: '',
      item_id: this.item.id,
      item_type: this.item.type,
    };
  }

  handleSubmit($event) {
    $event.preventDefault();
    const body = this.comment.body.trim();
    if (body) {
      this.comment.created_at = new Date;
      this.onCommentSubmit({comment: this.comment});
      this.initComment();
    }
  }
}

export default CommentFormController;



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/tasks/screens/task-detail/screens/task-detail-msgs/components/comment-form/comment-form.controller.js